import { useEffect } from "react";
import LegalLayout from "@/components/LegalLayout";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

export default function Cookies() {
    useEffect(() => {
        document.title = "Política de cookies — Aurum Vanguard";
        window.scrollTo({ top: 0 });
    }, []);

    const resetConsent = () => {
        try {
            localStorage.removeItem("av_cookies_v1");
            window.location.assign("/");
        } catch (_) {}
    };

    return (
        <>
            <Navigation />
            <LegalLayout
                title="Política de cookies"
                subtitle="Información clara sobre las cookies y tecnologías similares utilizadas en este sitio, conforme al RGPD, la LSSI-CE y la Directiva ePrivacy."
                lastUpdate="12 de mayo de 2026"
            >
                <h2>1. Qué son las cookies</h2>
                <p>
                    Las cookies son pequeños ficheros de texto que un sitio web puede instalar
                    en tu dispositivo cuando lo visitas. Permiten recordar información sobre tu
                    sesión y mejorar tu experiencia. Algunas son imprescindibles para que el
                    sitio funcione; otras son opcionales y requieren tu consentimiento previo.
                </p>

                <h2>2. Cookies que utiliza este sitio</h2>
                <p>
                    Hemos diseñado <strong>aurumvanguard.cloud</strong> con un enfoque de
                    privacidad por defecto: no instalamos cookies publicitarias, de
                    retargeting ni de terceros con fines de marketing.
                </p>
                <table>
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Tipo</th>
                            <th>Finalidad</th>
                            <th>Duración</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>av_cookies_v1</td>
                            <td>Técnica · esencial</td>
                            <td>
                                Recordar tu elección sobre el banner de cookies para no volver
                                a mostrártelo en cada visita.
                            </td>
                            <td>1 año (localStorage)</td>
                        </tr>
                        <tr>
                            <td>av_lang_v1</td>
                            <td>Técnica · esencial</td>
                            <td>
                                Recordar el idioma que has seleccionado para la web (ES/EN/IT).
                            </td>
                            <td>1 año (localStorage)</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    Ambos identificadores son almacenamiento local del navegador (no son
                    cookies HTTP en sentido estricto, sino <em>localStorage</em>) y se
                    consideran <strong>estrictamente necesarios</strong> conforme al art.
                    22.2 LSSI-CE, por lo que no requieren consentimiento previo. No se
                    transmiten al servidor ni se utilizan para identificar al usuario.
                </p>

                <h2>3. Cookies de terceros</h2>
                <p>
                    Cuando reservas una llamada a través del calendario embebido de{" "}
                    <strong>Cal.com</strong>, dicho proveedor puede instalar sus propias
                    cookies en tu navegador para gestionar la reserva. Esas cookies se rigen
                    por la política de privacidad y cookies de Cal.com.
                </p>

                <h2>4. Cómo gestionar tu consentimiento</h2>
                <p>
                    Puedes revocar o modificar tu elección en cualquier momento desde el
                    siguiente botón. Eliminaremos los identificadores locales y volveremos a
                    mostrarte el banner de consentimiento.
                </p>
                <p>
                    <button
                        type="button"
                        data-testid="reset-cookie-consent"
                        onClick={resetConsent}
                        className="inline-flex items-center gap-2 px-5 py-3 bg-[#1A1A1A] text-white text-sm tracking-wide hover:bg-[#8B6914] transition-colors"
                    >
                        Restablecer mi elección de cookies
                    </button>
                </p>
                <p>
                    También puedes bloquear o eliminar cookies y datos de sitios desde la
                    configuración de tu navegador (Chrome, Firefox, Safari, Edge, Brave).
                </p>

                <h2>5. Cambios</h2>
                <p>
                    Esta política se actualiza periódicamente. La fecha de la última revisión
                    aparece al inicio del documento.
                </p>
            </LegalLayout>
            <Footer />
        </>
    );
}
